export default () => ({
  loading: false,
  currentAgenda: {},
  currentProfessional: {},
  date: null,
  currentSchedule: {},
  showModal: false,
  agenda_id: null,
  agenda: {
    address: {},
    schedules: []
  },
  dates: [],
  optionLoadActions: [
    {value: 'scheduled', text: 'Agendado'},
    {value: 'delayed', text: 'Atrasado'},
    {value: 'attended', text: 'Atendido'},
    {value: 'absent', text: 'Ausente'},
    {value: 'canceled', text: 'Cancelado'},
    {value: 'in_attendance', text: 'Em Atendimento'},
    {value: 'present', text: 'Presente'}

  ],
  showModalCancel: false,
  hideShowModalCancel: false,
  showModalDelayed: false,
  showModalConfirmed: false,
  showModalAbsent: false,
  showModalInAttendance: false,
  showModalPresent: false,
  showModalFromDelayedRollback: false,
  showModalRollback: false,
  showModalTransfer: false,
  showModalReverser: false
})



// WEBPACK FOOTER //
// ./src/app/professional/dashboard/company/gadget/components/active-agenda/resources/data.js